import React from 'react'
import { IntegrationsXCartSec } from './integrationsXCartSec'

export const IntegrationsXCart = () => {
  return (
    <IntegrationsXCartSec />
  )
}
